<article>
	<app-page-title [label]="selectedNode?.label"></app-page-title>
	<h3>{{schematicCategory}}</h3>

	{{selectedNode?.data}}
</article>
